import {
  SESClient,
  SendEmailCommand,
  SendEmailCommandInput,
} from "@aws-sdk/client-ses";

import { ContactFormValues } from "src/components/molecules/ContactForm/ContactForm.d";
import { DEFAULT_EMAIL } from "src/constants";
import { EmailProps } from "./email.d";

const client = new SESClient({
  region: "sa-east-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID!,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY!,
  },
});

export const templates = {
  contact: (data: ContactFormValues): Partial<EmailProps> => {
    return {
      subject: `[Contact Form] Message about ${data.reason} by ${data.name} (${data.email})`,
      body: `${data.message}`,
    };
  },
};

export const sendEmail = ({
  subject,
  body,
  to = DEFAULT_EMAIL,
  from = DEFAULT_EMAIL,
}: Partial<EmailProps>) => {
  const emailParams: SendEmailCommandInput = {
    Destination: { ToAddresses: [to] },
    Message: {
      Subject: { Data: subject },
      Body: {
        Text: { Data: body },
      },
    },
    Source: from,
  };
  const command = new SendEmailCommand(emailParams);
  return client.send(command);
};
